import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ViewTab, ViewTabs } from 'components/ViewTabs';
import * as UiActions from 'actions/UiActions';
import { setAppToolbarToPendingStatus } from 'actions/AuthActions';
import 'css/HistoryPage.scss';
import MyBets from 'features/MyBets';
import { browserHistory } from 'react-router';
import { detectMobile } from 'utils/UiHelper';
import RestService from '../utils/RestService';
import Big9History from 'features/Big9History';
import InfoMessage from '../components/InfoMessageBage/InfoMessage';
import RetailSalesHistory from '../features/RetailSalesHistory/RetailSalesHistory';
import { FetchRetailSalesHistory } from '../actions/RetailSalesHistoryActions';

class HistoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: '0',
        };
    }

    onClickHandler(type) {
        if (type === 'log-ind' || type === 'sport/log-ind') {
            this.props.uiActions.setLoginModalStatus(true);
        } else {
            this.props.uiActions.setSignupModalStatus(true);
        }
    }

    loginModalOpen() {
        /**
         * shows spinner during RegisterDevice req
         */
        this.props.setAppToolbarToPendingStatus(true);

        /**
         * with requestion RegisterDevice we will know if there pin set (f.e from derby)
         */
        RestService.RegisterDevice(null, 'bet25-web', (pin_set) => {
            this.props.setAppToolbarToPendingStatus(false);

            this.props.uiActions.showModal('LOGIN_MOBILE');
        });
    }

    setTabIndex(pathname) {
        if (pathname === '/historik/aktive') {
            this.setState({ currentTab: '0' });
        } else if (pathname === '/historik/afsluttede') {
            this.setState({ currentTab: '1' });
        } else if (pathname === '/historik/big9') {
            this.setState({ currentTab: '2' });
        } else if (pathname === '/historik/butik') {
            this.setState({ currentTab: '3' });
        } else {
            this.setState({ currentTab: '0' });
        }
    }
    setTab(index) {
        if (index !== this.state.currentTab) {
            this.setState({ currentTab: index });
        }
    }

    componentDidMount() {
        if (this.props.tabIndex) {
            this.setState({ currentTab: this.props.tabIndex });
        } else {
            this.setTabIndex(window.location.pathname);
        }
        this.props.fetchRetailSalesHistory();
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.tabIndex !== undefined &&
            nextProps.tabIndex !== this.state.currentTab
        ) {
            this.setState({ currentTab: nextProps.tabIndex });
        }
    }
    openLoginPage = () => {
        detectMobile()
            ? this.props.uiActions.setLoginModalStatus(true)
            : browserHistory.push('/sport/log-ind');
    };

    render() {
        if (!this.props.auth.user) {
            return (
                <InfoMessage
                    text={'Du skal logge ind for at se dine væddemål'}
                />
            );
        } else {
            return (
                <div className="history-page">
                    {this.props.retailSalesHistory &&
                        this.props.retailSalesHistory.count !== null && (
                            <ViewTabs
                                currentTab={this.state.currentTab}
                                onTabChanged={this.setTab.bind(this)}
                            >
                                <ViewTab
                                    label="Aktive"
                                    key="0"
                                    style={{
                                        fontSize: '12px',
                                    }}
                                    onTabSelected={this.setTab.bind(this)}
                                >
                                    <MyBets active key={'active'} />
                                </ViewTab>
                                <ViewTab
                                    label="Afsluttede"
                                    key="1"
                                    onTabSelected={this.setTab.bind(this)}
                                >
                                    <MyBets key={'done'} />
                                </ViewTab>
                                <ViewTab
                                    label="Big 9"
                                    key="2"
                                    onTabSelected={this.setTab.bind(this)}
                                >
                                    <Big9History />
                                </ViewTab>
                                {this.props.retailSalesHistory.count > 0 && (
                                    <ViewTab
                                        label="Butik"
                                        key="3"
                                        onTabSelected={this.setTab.bind(this)}
                                    >
                                        <RetailSalesHistory />
                                    </ViewTab>
                                )}
                            </ViewTabs>
                        )}
                    <br />
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        loginModalStatus: state.ui.loginModalStatus,
        auth: state.auth,
        retailSalesHistory: state.retailSalesHistory,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
        setAppToolbarToPendingStatus: () => {
            return {
                setAppToolbarToPendingStatus: dispatch(
                    setAppToolbarToPendingStatus()
                ),
            };
        },
        fetchRetailSalesHistory: bindActionCreators(
            FetchRetailSalesHistory,
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HistoryPage);
